var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M20.668 0c.157.052.293.083.293.324-.01 1.681-.01 3.362-.01 5.044 0 .052-.021.104-.032.198-5.18-.25-9.546 1.463-12.815 5.577-2.203 2.778-3.185 5.995-3.05 9.536a14.069 14.069 0 0 0 1.432 5.629 14.322 14.322 0 0 0 3.55 4.616 14.564 14.564 0 0 0 5.066 2.851c1.88.616 3.822.742 5.817.68v5.493c-.136.02-.282.052-.428.052-.867-.01-1.744-.021-2.611-.063-.125-.01-.293-.146-.345-.271-.365-.752-.69-1.515-1.055-2.267-.073-.156-.271-.292-.438-.355-1.243-.418-2.496-.814-3.729-1.232-.25-.084-.428-.084-.647.042-.7.417-1.431.804-2.13 1.221-.189.115-.325.105-.492-.02a223.727 223.727 0 0 0-2.527-1.838c-.167-.126-.22-.24-.167-.46.188-.835.355-1.681.501-2.527a.665.665 0 0 0-.115-.44 174.662 174.662 0 0 0-2.391-3.278.847.847 0 0 0-.45-.293 44.423 44.423 0 0 0-2.37-.261c-.293-.031-.47-.125-.554-.428a86.187 86.187 0 0 0-.908-2.778c-.094-.272-.021-.45.198-.637a52.706 52.706 0 0 0 1.786-1.64.675.675 0 0 0 .188-.46c.01-1.347.01-2.704 0-4.052a.775.775 0 0 0-.209-.49C1.441 16.897.826 16.354.22 15.8c-.156-.146-.24-.271-.167-.5.334-.983.648-1.975.961-2.967.073-.23.23-.292.439-.313.793-.084 1.577-.178 2.37-.251.272-.02.429-.136.585-.365a91.483 91.483 0 0 1 2.246-3.081c.177-.23.24-.418.177-.7-.177-.783-.313-1.577-.501-2.37-.052-.22-.01-.335.167-.46a108.26 108.26 0 0 0 2.486-1.818c.219-.156.376-.125.595 0 .7.408 1.41.784 2.1 1.201.219.136.386.105.615.032 1.254-.429 2.517-.815 3.77-1.243a.778.778 0 0 0 .408-.345c.292-.585.574-1.17.815-1.775.177-.46.376-.867.96-.846h2.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M10.412 18.84h22.705v2.34H10.413a8.034 8.034 0 0 0 .835 2.82c.042.083.272.114.407.114 2.987.01 5.964 0 8.95 0 .7 0 1.41.01 2.11 0 .24 0 .376.074.512.272.752 1.138 1.514 2.277 2.267 3.415.125.199.26.293.5.272.377-.021.753-.01 1.108-.01v2.339c-.825 0-1.703.01-2.58-.01-.094 0-.198-.147-.26-.251-.763-1.139-1.515-2.277-2.288-3.405-.094-.136-.293-.272-.45-.272-2.777-.02-5.545-.01-8.323-.01-.063 0-.125.01-.24.031.93 1.337 1.4 2.757 1.326 4.428a11.793 11.793 0 0 1-3.394-2.412c-1.932-1.974-3.091-4.334-3.405-7.081-.71-6.214 3.238-10.726 6.789-12.272.094 1.62-.387 3.05-1.316 4.397.188.01.303.021.428.021 2.674 0 5.337 0 8.01.01.303 0 .47-.093.627-.344.731-1.128 1.483-2.235 2.225-3.352.125-.199.271-.272.5-.272.795.01 1.588.01 2.35.01v2.35c-.313 0-.688.021-1.054-.01-.261-.01-.418.073-.564.303-.72 1.117-1.473 2.203-2.193 3.32-.167.262-.366.346-.669.346-3.634-.01-7.268 0-10.903-.01-.324 0-.49.093-.606.396-.344.794-.616 1.619-.7 2.527Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M31.426 8.741c1.138 0 2.067.93 2.057 2.058a2.053 2.053 0 0 1-4.104-.032 2.04 2.04 0 0 1 2.047-2.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M37.441 22.057a2.032 2.032 0 0 1-2.036-2.036 2.035 2.035 0 0 1 2.068-2.047 2.04 2.04 0 0 1 2.036 2.036c0 1.128-.93 2.047-2.068 2.047Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M31.384 31.279a2.046 2.046 0 0 1-2.016-2.058 2.049 2.049 0 0 1 2.089-2.026c1.117.01 2.026.94 2.016 2.068 0 1.139-.94 2.037-2.09 2.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M28.543 4.187h-2.298V1.89h2.298v2.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M26.245 35.843h2.308v2.297h-2.308v-2.297Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16.482,
    x2: -5.593,
    y1: 6.494,
    y2: 14.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 27.617,
    x2: 9.866,
    y1: 12.682,
    y2: 28.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 32.605,
    x2: 29.39,
    y1: 9.404,
    y2: 11.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 38.631,
    x2: 35.416,
    y1: 18.637,
    y2: 21.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 32.595,
    x2: 29.379,
    y1: 27.858,
    y2: 30.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 28.052,
    x2: 26.245,
    y1: 2.263,
    y2: 3.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 28.06,
    x2: 26.251,
    y1: 36.216,
    y2: 37.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h39.499v40H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurting);
export default __webpack_public_path__ + "static/media/curting.f5118cfa4c38c38f6a0ac60f29c74356.svg";
export { ForwardRef as ReactComponent };